// extracted by mini-css-extract-plugin
export default {"DetailStatisticsDiv":"DetailStatistics_DetailStatisticsDiv__-11D+","content":"DetailStatistics_content__01W4s","btns":"DetailStatistics_btns__6dIRC"};